import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    rounded: "",
    elevation: "1",
    class: "bg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Résumé ")
        ])),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice, key) => {
        return (_openBlock(), _createBlock(_component_v_card_text, {
          key: key,
          class: "d-flex justify-space-between"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(invoice.title), 1)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.newCommonFormatCurrency(invoice.amountSigned)), 1)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (_ctx.invoices.length !== 1)
        ? (_openBlock(), _createBlock(_component_v_card_text, {
            key: 0,
            class: "d-flex justify-space-between"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                _createElementVNode("strong", null, "Total")
              ], -1)),
              _createElementVNode("div", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalAmountSigned)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card_actions, { class: "d-flex justify-space-between" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_icon, {
            variant: "elevated",
            size: "x-small",
            icon: "$cloud_download",
            color: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadDocument()))
          }),
          (_ctx.type === 'devis' && _ctx.data.isSignature && _ctx.data.isAlreadySigned)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                label: "",
                color: "primary",
                variant: "flat",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createTextVNode("Signé ")),
                  _createVNode(_component_v_icon, {
                    size: "x-small",
                    right: "",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("$fa-check")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_ctx.type === 'devis' && _ctx.data.isSignature)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  variant: "elevated",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.askForSignature()))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Signer le devis")
                  ])),
                  _: 1
                }))
              : (
                    _ctx.type === 'facture' && _ctx.data.isPaymentLink && _ctx.data.accountingLines.length == 1
                )
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPaymentLink())),
                    variant: "elevated",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Payer " + _toDisplayString(_ctx.data.accountingLines.length > 1 ? "les" : "la") + " facture" + _toDisplayString(_ctx.data.accountingLines.length > 1 ? "s" : ""), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}